/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2494
 */

module.exports = function (e, t) {
  return null == e ? undefined : e[t]
}
